<h1 class="cdk-visually-hidden">{{ pageTitle }}</h1>
@for (section of sections; track section) {
  @if (section.code === portalHomepageSections.ABOUT) {
    <div class="top-sections">
      @if (media.is('gt-sm')) {
        <img src="assets/images/white-spots.svg" class="white-spots" alt="" />
      }
      @if (media.is('gt-sm') && isSearchActive) {
        <esp-portal-title></esp-portal-title>
      }
      <esp-portal-intro></esp-portal-intro>
    </div>
  }
  @if (section.code === portalHomepageSections.FEATURED_COLLECTIONS) {
    <esp-portal-featured-collections
      >
    </esp-portal-featured-collections>
  }
  @if (section.code === portalHomepageSections.CUSTOM_LINK_1) {
    <esp-portal-free-links
      [customLinks]="customLink1"
      sectionNumber="1"
    ></esp-portal-free-links>
  }
  @if (section.code === portalHomepageSections.CUSTOM_LINK_2) {
    <esp-portal-free-links
      [customLinks]="customLink2"
      sectionNumber="2"
    ></esp-portal-free-links>
  }
  @if (section.code === portalHomepageSections.CUSTOM_LINK_3) {
    <esp-portal-free-links
      [customLinks]="customLink3"
      sectionNumber="3"
    ></esp-portal-free-links>
  }
  @if (section.code === portalHomepageSections.CUSTOM_LINK_4) {
    <esp-portal-free-links
      [customLinks]="customLink4"
      sectionNumber="4"
    ></esp-portal-free-links>
  }
  @if (section.code === portalHomepageSections.CUSTOM_LINK_5) {
    <esp-portal-free-links
      [customLinks]="customLink5"
      sectionNumber="5"
    ></esp-portal-free-links>
  }
  @if (section.code === portalHomepageSections.DOWNLOAD_MAP) {
    <esp-portal-download-map></esp-portal-download-map>
  }
  @if (
    section.code === portalHomepageSections.FEATURED_RESEARCHER &&
    configurationHandlerService.isProfileActivate() &&
    researchers?.length > 0
    ) {
    <esp-portal-researchers
      [researchers]="researchers"
    ></esp-portal-researchers>
  }
  @if (section.code === portalHomepageSections.STATISTICS) {
    <esp-portal-usage></esp-portal-usage>
  }
  @if (section.code === portalHomepageSections.TOP_TEN && section.topTenOptions?.length) {
    <esp-portal-featured
    ></esp-portal-featured>
  }
  @if (section.code === portalHomepageSections.WORKS_ADDED) {
    <esp-portal-additions></esp-portal-additions>
  }
}
